<template>
    <div>
        <a-card size="small" title="平台管理">
            <!--         <div slot="extra" class="topBtnBlock">
            <a-button type="primary" @click="handleShow()">新建</a-button>
            
        </div> -->

            <a-modal :title="modalTitle" :visible="isShow" :confirm-loading="confirmLoading" width="650px" @cancel="handleCancel">
                <a-form-model layout="inline" :model="configItem" ref="ruleForm" :rules="rules">
                    <a-form-model-item label="平台编码" ref="platformcode" prop="platformcode">
                        <a-input style="width:200px;" v-model="configItem.platformcode" placeholder="平台编码" allow-clear></a-input>
                    </a-form-model-item>
                    <a-form-model-item label="平台名称" ref="platformname" prop="platformname">
                        <a-input style="width:200px;" v-model="configItem.platformname" placeholder="平台名称" allow-clear></a-input>
                    </a-form-model-item>
                </a-form-model>
                <template slot="footer">
                    <a-button key="back" @click="handleCancel">
                        取消
                    </a-button>
                    <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleSave">
                        确定
                    </a-button>
                </template>

            </a-modal>

            <a-form layout="inline" :form="form" class="myform" @keyup.enter.native="handleSubmit">
                <a-form-item label="关键字">
                    <a-input v-model="searchP.keyword" placeholder="输入关键字" allow-clear />
                </a-form-item>

                <a-form-item>
                    <a-button type="primary" @click="handleSubmit">搜索</a-button>
                </a-form-item>

            </a-form>

            <a-table :columns="columns" :data-source="tableData" :scroll="{ x: clientWidth}" class="mt20" :pagination="false" :loading="tloading" rowKey="platformcode" @change="handleTableChange">
                <!--                 <template slot="operation" slot-scope="text, record">
                    <a-button type="link" @click="handleShow(record)">编辑</a-button>

                    <a-popconfirm title="确认删除?" @confirm="() => handleDelete(record)">
                        <a class="tableLink" href="javascript:;">删除</a>
                    </a-popconfirm>

                </template> -->
            </a-table>
            <a-pagination style="float:right;margin-top:20px;" v-model="pagination.page" :pageSize="pagination.pageSize" :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />
        </a-card>

    </div>
</template>
<script>
let pagination = {
    page: 1,
    pageSize: 10,
    total: 0,
}

const columns = [
    {
        title: '序号',
        width: 50,
        align: 'center',
        customRender: (text, record, index) => {
            let { page, pageSize } = pagination
            return (Number(page) - 1) * Number(pageSize) + index + 1
        },
    },
    {
        title: '平台编码',
        dataIndex: 'platformcode',
        align: 'center',
        width: 80,
    },
    {
        title: '平台名称',
        dataIndex: 'platformname',
        align: 'center',
        width: 80,
    },

    /*     {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 150,
        scopedSlots: { customRender: 'operation' },
    }, */
]

export default {
    data() {
        return {
            confirmLoading: false,
            form: this.$form.createForm(this),
            modalTitle: '',
            searchP: {
                keyword: '',
            },
            columns,
            tableData: [],
            tloading: false,
            pagination,
            clientWidth: 800,
            ordercoloum: 'total',
            orderstr: 'desc',
            isShow: false,
            rules: {
                platformname: [
                    { required: true, message: ' 请输入 ', trigger: 'blur' },
                ],
                platformcode: [
                    { required: true, message: ' 请输入 ', trigger: 'blur' },
                ],
            },
            configItem: {
                id: '',
                platformcode: '',
                platformname: '',
            },
        }
    },
    computed: {},
    methods: {
        handleSave() {
            let that = this
            that.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    that.confirmLoading = true
                    if (that.configItem.id != '') {
                        that.$store
                            .dispatch({
                                type: 'filemanager/editPlatformPage',
                                params: that.configItem,
                            })
                            .then((response) => {
                                if (response.data.success == '1') {
                                    that.handleCancel()
                                    that.confirmLoading = false
                                }
                            })
                    } else {
                        //新增
                        that.$store
                            .dispatch({
                                type: 'filemanager/addPlatformPage',
                                params: that.configItem,
                            })
                            .then((response) => {
                                if (response.data.success == '1') {
                                    that.handleCancel()
                                    that.confirmLoading = false
                                }
                            })
                    }
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        handleShow(record) {
            this.isShow = true
            let that = this
            if (record) {
                that.$store
                    .dispatch({
                        type: 'filemanager/detailPlatformPage',
                        params: {
                            ...record,
                        },
                    })
                    .then((response) => {
                        if (response.data.success == '1') {
                            that.configItem = response.data.data
                        }
                    })
            } else {
                this.configItem = {
                    id: '',
                    platformcode: '',
                    platformname: '',
                }
            }
        },
        handleCancel() {
            this.configItem = {
                platformcode: '',
                platformname: '',
            }
            this.isShow = false
            this.pagination.page = 1
            this.getAppSumData()
        },

        handleSubmit() {
            this.pagination.page = 1
            this.getAppSumData()
        },
        handleTableChange(d, v, sorter) {
            if (sorter.order) {
                this.ordercoloum = sorter.field
                this.orderstr = sorter.order.replace('end', '')
            } else {
                this.ordercoloum = ''
                this.orderstr = ''
            }

            this.getAppSumData()
        },
        handlePageChange(v) {
            this.pagination.page = v
            this.getAppSumData()
        },
        handleDelete(item) {
            let that = this
            that.$store
                .dispatch({
                    type: 'filemanager/delPlatformPage',
                    params: { id: item.id },
                })
                .then((res) => {
                    if (res.status == '200') {
                        that.pagination.page = 1
                        that.getAppSumData()
                    }
                })
        },
        getAppSumData() {
            let that = this
            that.tloading = true
            let params = {
                ...that.searchP,
                ...that.pagination,
                urlparams: false,
            }
            that.$store
                .dispatch({
                    type: 'filemanager/queryPlatformPage',
                    params: params,
                })
                .then((res) => {
                    if (res.status == 200 && res.data.success == '1') {
                        let result = res.data.data
                        this.tableData = result.list
                        this.pagination.total = parseInt(result.totalRecords)
                        this.pagination.pageSize = parseInt(result.pageSize)
                        this.pagination.page = parseInt(result.page)
                    }
                    that.tloading = false
                })
                .catch(() => {
                    that.tloading = false
                })
        },
    },
    components: {},
    mounted() {
        this.handleSubmit()
    },
}
</script>
<style scoped>
</style>
